<!--用户下拉选择器-->
<template>
    <el-select size="small" v-model="item.id" filterable :disabled="disabled" placeholder="请输入关键词" @change="handleChange" :clearable="clearable">
        <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.name"
                :value="item.id"
        >
        </el-option>
    </el-select>
</template>


<script>
    import UserService from "~/services/user";
    import {isNumber} from 'util';
    export default {
        props: {
            uid: '',//当前选择的uid，
            disabled:false,
            name:'',
            clearable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                uids: null,
                item: {
                    name:'',
                    id:''
                },
                users: []
            };
        },

        created: function () {
            UserService.getAll({
                fields: "id,name",
                scenario: "all-user"
            }).then(res => {
                if (res.code == 0) {
                    this.users = res.data
                }
            })
            if (typeof this.uid != 'undefined' && this.uid>0) {
                this.uids = this.uid;
                /**
                 * 默认选中
                 */
                if (isNumber(this.uids)) {
                    this.getDefault(this.uids);
                }
            }else{
                this.item.name = this.name;
            }
        },
        watch:{
            uid:function(value){
                if (isNumber(value) && value>0) {
                    this.getDefault(value);
                }else{
                    this.reset();
                }
            }
        },
        methods: {
            getDefault(uid) {
                let params = {
                    fields: 'id,name',
                    id: uid,
                    scenario: 'all-user'
                };
                UserService.getAll(params).then(res => {
                    if (!res.data || res.data.length == 0) {
                        return;
                    }
                    this.item = res.data[0];
                });
            },

            //select value值变化时触发
            handleChange(user_id) {
                if(user_id){
                    const user = this.users.find(user => user.id === user_id);
                    this.item = user;
                }else{
                    this.item = {
                        name:'',
                        id:''
                    };
                }
                
                this.$emit("change", this.item);
            },

            //对输入框进行重置
            reset() {
                this.uids = '';
                this.item = {
                    name:'',
                    id:''
                };
            }
        },
    }


</script>


// WEBPACK FOOTER //
// src/widgets/OrderUserSelect.vue